/**************************************************
 * Nombre:       Detalle_Producto_Img_Caracteristicas_Img
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import '@splidejs/react-splide/css';
import {useEffect, useRef, useState} from "react";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import 'photoswipe/dist/photoswipe.css'
import {Gallery, Item} from "react-photoswipe-gallery";
import {theme} from "../../../Tema";


const Detalle_Producto_Img_Caracteristicas_Img = ({producto, seleccionada}) => {
    const {sCell, masSM} = useResponsive()
    const refe = useRef(null)
    const [imgs, setImgs] = useState([])


    useEffect(() => {

        let imgs = []

        if (producto.variaciones && producto.variaciones.length) {
            for (let i = 0; i < producto.variaciones.length; i++) {
                if (producto.variaciones[i].img) {
                    imgs.push(producto.variaciones[i].img)
                }
            }

            imgs.push(producto.img)

            if (producto.imgs) {
                imgs.push(...producto.imgs)
            }

            setImgs(imgs)
        } else {
            setImgs([producto.img])
            if (producto.imgs) {
                setImgs(it => it.concat(...producto.imgs))
            }
        }


    }, [producto]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <img src={seleccionada && seleccionada.img ? seleccionada.img : producto.img}
                     width={sCell ? '95%' : '82%'} height={'auto'}
                />
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={1}
                >


                    <Gallery>
                        {imgs.map((item, index) => {
                            return (

                                <Item
                                    original={item}
                                    thumbnail={item}
                                    width="1500"
                                    height="1500"
                                >
                                    {({ref, open}) => (
                                        <Grid container size={{xs: 3, sm: 3, md: 2}}
                                              sx={{border: 1, borderColor: theme.palette.primary.main + 40}}>
                                            <img ref={ref} onClick={open} width={'100%'} src={item}
                                            />
                                        </Grid>

                                    )}
                                </Item>


                            )
                        })}

                    </Gallery>

                </Grid>


            </Grid>


        </Grid>
    )

}
export default Detalle_Producto_Img_Caracteristicas_Img

